import { updateStateSchema } from "../../../core/state/utils/setStateSchema";
import { triggerSourceUpdate } from "../../../tools/designer/triggerSourceUpdate";
import { migrateDataSchema } from '@tencent/data-schema-core';
import { fromJsonData } from '@tencent/data-schema-core/lib/convertor/jsonData';
import { get } from "lodash-es";
export function schemaProcessFuncFactory(key) {
  return ({
    designer,
    instance
  }) => {
    var _instance$stateSchema;
    const value = get(instance, key);
    const oldSchema = (_instance$stateSchema = instance.stateSchema.fields) === null || _instance$stateSchema === void 0 ? void 0 : _instance$stateSchema.find(item => item.id === key);
    let newSchema = fromJsonData(value);
    if (oldSchema) {
      newSchema = migrateDataSchema(oldSchema, newSchema, ['ui']);
    }
    const succ = upsertVariableSchema({
      designer,
      instance,
      variableName: key,
      newSchema
    });
    return {
      succ,
      schema: newSchema
    };
  };
}
export function clearVariableSchema(options) {
  const {
    variableName
  } = options;
  const sourceConfig = getSource(options);
  const fields = sourceConfig === null || sourceConfig === void 0 ? void 0 : sourceConfig.fields;
  if (!Array.isArray(fields) || !sourceConfig) return false;
  const index = fields.findIndex(item => item.id === variableName);
  if (index >= 0) {
    fields.splice(index, 1);
  }
  updateAndTrigger(sourceConfig, options);
  return true;
}
export function upsertVariableSchema(options) {
  const {
    variableName,
    newSchema
  } = options;
  const sourceConfig = getSource(options);
  if (!sourceConfig) return false;
  sourceConfig.fields = sourceConfig.fields || [];
  const {
    fields
  } = sourceConfig;
  const index = fields.findIndex(item => item.id === variableName);
  if (index >= 0) {
    fields.splice(index, 1, newSchema);
  } else {
    fields.push(newSchema);
  }
  updateAndTrigger(sourceConfig, options);
  return true;
}
function getSource(options) {
  var _designer$rootPagelet;
  const {
    designer,
    instance
  } = options;
  const sourceId = getSourceIdByInstance(instance);
  const sourceConfig = (_designer$rootPagelet = designer.rootPagelet.xySources) === null || _designer$rootPagelet === void 0 ? void 0 : _designer$rootPagelet.find(item => item.id === sourceId);
  return sourceConfig;
}
/**
 * 触发ui更新
 * @param sourceConfig
 * @param options
 */
function updateAndTrigger(sourceConfig, options) {
  const {
    designer,
    instance,
    variableName
  } = options;
  instance.options.sourceConfig = sourceConfig;
  updateStateSchema(instance, variableName);
  triggerSourceUpdate(designer, getSourceIdByInstance(instance));
}
function getSourceIdByInstance(instance) {
  var _instance$options$sou;
  return ((_instance$options$sou = instance.options.sourceConfig) === null || _instance$options$sou === void 0 ? void 0 : _instance$options$sou.id) || '';
}
export function getCustomVarSchema(designer, sourceId, variableName) {
  var _designer$rootPagelet2, _sourceConfig$fields;
  const sourceConfig = (_designer$rootPagelet2 = designer.rootPagelet.xySources) === null || _designer$rootPagelet2 === void 0 ? void 0 : _designer$rootPagelet2.find(item => item.id === sourceId);
  if (!sourceConfig) return null;
  return (_sourceConfig$fields = sourceConfig.fields) === null || _sourceConfig$fields === void 0 ? void 0 : _sourceConfig$fields.find(item => item.id === variableName);
}
//# sourceMappingURL=common.js.map
